import Link from 'next/link'
import { useEffect, useRef, useState } from 'react'

import { PhnxButton } from '@/components/01-atoms/Button/Button'
import { PhnxLogo } from '@/components/01-atoms/Logo/Logo'

import styles from './Header.module.css'

// types.ts
export interface NavLink {
  text: string
  toggleDropdown: boolean
  href: string
}

export interface HeaderProps {
  headerNavigation: any
  findOfficeCtaText: string
  dropdownData: any
  mobileMenuData: any
  findOfficeCtaLink: {
    story: {
      fullSlug: string
    }
  }
  contactCtaText: string
  contactCtaLink: {
    story: {
      fullSlug: string
    }
  }
}

export const Header: React.FC<HeaderProps> = ({
  headerNavigation,
  dropdownData,
  mobileMenuData,
  findOfficeCtaText,
  findOfficeCtaLink,
  contactCtaText,
  contactCtaLink,
}) => {
  const [showNav, setShowNav] = useState<boolean | null>(null)
  const [showMobileMenu, setShowMobileMenu] = useState(false)

  const toggleDropdownNav = () => {
    setShowNav(!showNav)
  }

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu)
  }

  const handleDropdownClose = () => {
    setShowNav(false)
  }

  return (
    <header className={styles.siteHeader}>
      <div className={styles.siteHeaderLogo}>
        <PhnxLogo className={styles.logo} />
      </div>
      <div className={styles.siteHeaderLinks}>
        {headerNavigation &&
          headerNavigation.map((nav: any, index: any) => (
            <div key={index} className={`${styles.siteHeaderLink} d-none d-lg-flex`}>
              {!nav.toggleDropdown ? (
                <Link href={`${nav.href ? nav.href : ''}`}>{nav.text}</Link>
              ) : (
                <button
                  className={`${styles.toggleDropdown} toggleDropdown`}
                  type="button"
                  onClick={toggleDropdownNav}
                >
                  {nav.text}
                  <span className={(showNav ? 'navOpen' : '') + ' fx-icon-arrow-down-lg'}></span>
                </button>
              )}
            </div>
          ))}
        <Link
          href={`${findOfficeCtaLink.story.fullSlug}`}
          className={`${styles.findAnOffice} ${styles.siteHeaderLink}`}
        >
          <img
            src="data:image/svg+xml;base64,PHN2ZyBpZD0iYmQ0NzAzNWUtMDFlMy00MGVhLThjZWUtMDZlMzE5NTY0NThlIiBkYXRhLW5hbWU9ImE4MmRiMmQ5LWUwZmQtNDA1OS1hNTMxLTI0NDZjYWExMDI2MyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCI+PHRpdGxlPmZ4LWljb24tbWFya2VyLXdoLnN2ZzwvdGl0bGU+PHBhdGggZD0iTTMxLjgyLDEuOTMyMUEyMS45NjA4LDIxLjk2MDgsMCwwLDAsOS44NTg4LDIzLjg5MjlDOS44NTg4LDM2LjAyMTUsMzEuODIsNjEsMzEuODIsNjFTNTMuNzgwNSwzNi4wMjE1LDUzLjc4MDUsMjMuODkyOUEyMS45NjA4LDIxLjk2MDgsMCwwLDAsMzEuODIsMS45MzIxWm0tLjAxOTEsMzEuNTg0MmE5LjgyNTUsOS44MjU1LDAsMSwxLDkuODI1My05LjgyNTZoMGE5LjgyNTMsOS44MjUzLDAsMCwxLTkuODI1MSw5LjgyNTVaIiBmaWxsPSIjZmZmIi8+PC9zdmc+"
            alt="Office icon"
          />
          {findOfficeCtaText}
        </Link>
      </div>
      <div className={styles.mobileHeader}>
        <button className={styles.mobileFindAnOfficeButton} onClick={toggleMobileMenu}>
          <img
            src="data:image/svg+xml;base64,PHN2ZyBpZD0iYmQ0NzAzNWUtMDFlMy00MGVhLThjZWUtMDZlMzE5NTY0NThlIiBkYXRhLW5hbWU9ImE4MmRiMmQ5LWUwZmQtNDA1OS1hNTMxLTI0NDZjYWExMDI2MyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCI+PHRpdGxlPmZ4LWljb24tbWFya2VyLXdoLnN2ZzwvdGl0bGU+PHBhdGggZD0iTTMxLjgyLDEuOTMyMUEyMS45NjA4LDIxLjk2MDgsMCwwLDAsOS44NTg4LDIzLjg5MjlDOS44NTg4LDM2LjAyMTUsMzEuODIsNjEsMzEuODIsNjFTNTMuNzgwNSwzNi4wMjE1LDUzLjc4MDUsMjMuODkyOUEyMS45NjA4LDIxLjk2MDgsMCwwLDAsMzEuODIsMS45MzIxWm0tLjAxOTEsMzEuNTg0MmE5LjgyNTUsOS44MjU1LDAsMSwxLDkuODI1My05LjgyNTZoMGE5LjgyNTMsOS44MjUzLDAsMCwxLTkuODI1MSw5LjgyNTVaIiBmaWxsPSIjZmZmIi8+PC9zdmc+"
            alt="Find an Office"
          />
        </button>
        <button className={styles.mobileToggleButton} onClick={toggleMobileMenu}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
          >
            <path
              d="M11.75 15.1923H0.75V13.359H11.75V15.1923ZM17.25 8.91665H0.75V7.08332H17.25V8.91665ZM11.75 2.64101H0.75V0.807678H11.75V2.64101Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
      <div className={styles.siteHeaderButton}>
        <PhnxButton
          variant="primary"
          size="default"
          type="link"
          href={contactCtaLink?.story?.fullSlug}
          label={contactCtaText}
          disabled={false}
          openInNewWindow={false}
        />
      </div>
      <HeaderDropdown
        isVisible={showNav}
        dropdownData={dropdownData}
        onClose={handleDropdownClose}
      />
      <MobileMenu
        isVisible={showMobileMenu}
        toggleMobileMenu={toggleMobileMenu}
        mobileMenuData={mobileMenuData}
      />
    </header>
  )
}

interface HeaderDropdownProps {
  isVisible: boolean | null
  dropdownData: any
  onClose: () => void // Add onClose callback prop
}

const HeaderDropdown: React.FC<HeaderDropdownProps> = ({ isVisible, dropdownData, onClose }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isNavVisible, setIsNavVisible] = useState<boolean | null>(isVisible)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isVisible &&
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        if (
          (event.target as HTMLElement)?.classList.contains('navOpen') ||
          (event.target as HTMLElement)?.classList.contains('toggleDropdown')
        ) {
          return
        }
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isVisible, onClose])

  // when the dropdown is closed we need to set a delay on the hidden class
  useEffect(() => {
    if (!isVisible) {
      setTimeout(() => {
        setIsNavVisible(false)
      }, 150)
    } else {
      setIsNavVisible(isVisible)
    }
  }, [isVisible])

  return (
    <div
      ref={containerRef}
      className={`${styles.dropdown} ${isVisible ? `animate-slide-from-top ${styles.visible}` : `animate-slide-to-top ${!isNavVisible ? styles.hide : ''}`}`}
    >
      <div className={styles.megaNav}>
        {dropdownData &&
          dropdownData.map((categoryData: any, index: any) => (
            <div key={index} className={styles.dropdownCategory}>
              <div className={styles.dropdownHeading}>
                <h3>
                  <Link href={categoryData.links[0].href as string} tabIndex={isVisible ? 0 : -1}>
                    {categoryData.links[0].text}
                  </Link>
                </h3>
              </div>
              {categoryData.links.slice(1).map((subcategoryData: any, subIndex: any) => (
                <div key={subIndex} className={styles.dropdownGroup}>
                  <h4 className={styles.dropdownGroupHeading}>{subcategoryData.subcategory}</h4>
                  {subcategoryData &&
                    subcategoryData.links &&
                    subcategoryData?.links.map((link: any, linkIndex: any) => (
                      <div key={linkIndex} className={styles.dropdownGroupItem}>
                        <Link href={link.href} tabIndex={isVisible ? 0 : -1}>
                          {link.text}
                        </Link>
                      </div>
                    ))}
                </div>
              ))}
            </div>
          ))}
      </div>
    </div>
  )
}

const MobileMenu = ({
  isVisible,
  toggleMobileMenu,
  mobileMenuData,
}: {
  isVisible: boolean
  toggleMobileMenu: () => void
  mobileMenuData: any
}) => {
  return (
    <>
      <div
        className={`${styles.mobileMenu} ${isVisible ? 'right-0 opacity-100' : '-right-[300px] opacity-0'}`}
      >
        <div className={styles.mobileMenuContainer}>
          <div className={styles.home}>
            <Link href="/" aria-current="page" tabIndex={isVisible ? 0 : -1}>
              Home
            </Link>
            <button
              className="fx-icon-dismiss-lg"
              onClick={toggleMobileMenu}
              aria-label="Close mobile menu"
            />
          </div>
          <div className={styles.navigation}>
            {mobileMenuData &&
              mobileMenuData.navigation1.map((link: any, index: any) => (
                <div key={index}>
                  <Link href={link.href} tabIndex={isVisible ? 0 : -1}>
                    {link.text}
                  </Link>
                </div>
              ))}
          </div>
          <div className={styles.navigation}>
            {mobileMenuData &&
              mobileMenuData.navigation2.map((link: any, index: any) => (
                <div key={index}>
                  <Link href={link.href} tabIndex={isVisible ? 0 : -1}>
                    {link.text}
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </div>
      {/* eslint-disable */}
      {isVisible && <div className={styles.mobileOverlay} onClick={toggleMobileMenu}></div>}
    </>
  )
}
